import { FindPatternGameData } from '../components/findpatterngame';
import { Board } from './wordboard';
import { Profile, newProfile } from './profile'
import { Plugins } from '@capacitor/core'

const GameStorageKey = "VOWELS_SAVE"
const ProfileStorageKey = "VOWELS_PROFILE"
const GameDataVersion = 2
const ProfileDataVersion = 1

//we keep this data separate so that if we change the game logic, the compiler warns us the storage format is out of date.

interface SaveGameData {
    data_version: number,
    board: Board,
    removeLetters: boolean,
    patternList: string[],
    currentPatternIdx: number,
    foundWords: number[]
}

interface StatisticsData {
    bestTimes: { [cols: string]: number }
    gamesCompleted: { [cols: string]: number }
    lastTimes: { [cols: string]: number[] }
    wordsFound: number,
    bonusWordsFound: number
}

interface RankProgressData {
    rankId: string,
    progress: number
}

interface SaveProfileData {
    data_version: number,
    lastUpdated: number,
    rankProgress: RankProgressData,
    statsData: StatisticsData
}

function migrateSaveData(saveData: SaveGameData) {
    if (saveData.data_version < 2)  {
        saveData.removeLetters = false;
    }
}


export async function loadGame(): Promise<FindPatternGameData> {
    var stateString = await getVal(GameStorageKey);
    if (!stateString) return null;
    try {
        var saveData = JSON.parse(stateString) as SaveGameData;
        migrateSaveData(saveData);
        return {
            ...saveData
        }
    } catch {
        return null;
    }
}

export async function saveGame(gameState: FindPatternGameData): Promise<void> {
    let saveData:SaveGameData = {
        data_version: GameDataVersion,
        ...gameState
    }

    var saveString = JSON.stringify(saveData)
    await setVal(GameStorageKey, saveString);
}


function migrateProfileData(profileData: SaveProfileData) {
    //migrate here eg.
    //if (profileData.data_version < 2)  {
        //
   // }
}

export async function saveProfile(profile: Profile): Promise<void> {
    let data: SaveProfileData = {
        data_version: ProfileDataVersion,
        rankProgress: {
            ...profile.rankProgress
        },
        statsData: {
            ...profile.stats
        },
        lastUpdated: profile.lastUpdated
    }
    let data_str = JSON.stringify(data);
    await setVal(ProfileStorageKey, data_str)
}

export async function loadProfile():Promise<Profile> {
    let data_str = await getVal(ProfileStorageKey);
    if (!data_str) {
        return newProfile();
    }
    try {
        let data = JSON.parse(data_str) as SaveProfileData;
        migrateProfileData(data);
        let p:Profile = {
            stats: data.statsData,
            rankProgress: data.rankProgress,
            lastUpdated: data.lastUpdated
        }
        return p
    } catch {
        return newProfile();
    }
}

async function setVal(name: string, value: string): Promise<void> {
    try {
       await Plugins.Storage.set({key: name, value: value})
    } catch (e){
        console.error(e);
    }
}

async function getVal(name: string): Promise<string> {
    try {
        let res =  await Plugins.Storage.get({ key: name })
        if (res) return res.value
        return null;
    } catch (e){
        console.error(e);
        return null;
    }
}